import { useAppSelector } from 'hooks/use-app-selector';
import { selectAccountPermissions } from 'store/account';

export const usePermissions = () => {
  return useAppSelector(selectAccountPermissions);
};
